import { render, staticRenderFns } from "./DemandReasonDisplay.vue?vue&type=template&id=6b0adf76&"
import script from "./DemandReasonDisplay.vue?vue&type=script&lang=js&"
export * from "./DemandReasonDisplay.vue?vue&type=script&lang=js&"
import style0 from "./DemandReasonDisplay.vue?vue&type=style&index=0&id=6b0adf76&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports